import { Link } from 'components/PerformanceReturns/PerformanceReturnsStyles';
import {
  AccordionContent,
  BreadCrumbs,
  Container,
  Header,
  Hr,
  PerformanceReturnAccordion,
  SubTitle,
  Title,
} from './PerformanceReturnDetailsStyles';
import { ReturnTable } from './ReturnTable';
import { usePerformanceReturnDetailsData } from './usePerformanceReturnDetailsData';
import {
  DEFAULT_DATE_FORMAT_WITH_TIME,
  dateISOStringToFormat,
} from 'helpers/formatters/date';
import { PerformanceTable } from './PerformanceTable';
import { GetBenchmarkNameById } from 'modules/Benchmarks/BenchmarkList/utils';
import { Stream } from 'types/PerformanceReturns';
import { Button } from 'components/Button';
import { Export } from 'components/Icons';

type Props = {
  stream?: Stream | null;
  asOfDate?: string;
  streamCompare?: Stream | null;
  onBack?: () => void;
};

export const PerformanceReturnDetails = ({
  stream,
  asOfDate,
  streamCompare,
  onBack,
}: Props) => {
  const formattedDate = dateISOStringToFormat(asOfDate ?? '');
  const { data, dataCompare, isLoading } = usePerformanceReturnDetailsData({
    streamId: stream?.streamId,
    asOfDate,
    streamCompareId: streamCompare?.streamId,
  });

  // TODO: need to wire this up
  const downloadHandler = () => {};

  return (
    <Container>
      <Header>
        <BreadCrumbs>
          <Link onClick={onBack}>Performance Returns</Link>
          <div>&gt;</div>
          <div>
            {streamCompare ? `Compare Returns ` : `Return `}
            for Month End {formattedDate}
          </div>
        </BreadCrumbs>

        <Button onClick={downloadHandler} variant='secondary'>
          <Export size={'14px'} />
          Download Tables
        </Button>
      </Header>

      <PerformanceReturnAccordion
        headerElements={
          <Title>
            {streamCompare ? `Compare Returns ` : `Return `} for Month End{' '}
            {formattedDate}
          </Title>
        }
        isOpened={true}
      >
        <AccordionContent>
          <ReturnTable
            isLoading={isLoading}
            data={data}
            stream={stream}
            dataCompare={dataCompare}
            streamCompare={streamCompare}
          />
        </AccordionContent>
      </PerformanceReturnAccordion>

      <Hr />

      {!isLoading ? (
        <>
          <PerformanceReturnAccordion
            headerElements={
              <Title>
                {dataCompare
                  ? `Compare Performance for `
                  : `Performance as of `}{' '}
                Month End {formattedDate}
              </Title>
            }
            isOpened={true}
          >
            <AccordionContent>
              <SubTitle>
                {GetBenchmarkNameById(data?.benchmark?.typeId)} Benchmark{' '}
                {stream && streamCompare
                  ? dateISOStringToFormat(
                      stream.dateCreated,
                      DEFAULT_DATE_FORMAT_WITH_TIME
                    )
                  : null}
              </SubTitle>
              <PerformanceTable data={data} isLoading={isLoading} />
              {streamCompare ? (
                <>
                  <SubTitle style={{ marginTop: 40 }}>
                    {GetBenchmarkNameById(data?.benchmark?.typeId)} Benchmark{' '}
                    {dateISOStringToFormat(
                      streamCompare.dateCreated,
                      DEFAULT_DATE_FORMAT_WITH_TIME
                    )}
                  </SubTitle>
                  <PerformanceTable data={dataCompare} isLoading={isLoading} />
                </>
              ) : null}
            </AccordionContent>
          </PerformanceReturnAccordion>
          <Hr />
        </>
      ) : null}
    </Container>
  );
};
